import { Map, MapLayerMouseEvent } from 'maplibre-gl';
import { getFirstLabelId } from '@/utils/map';
import { colors, hslStringToHex } from '@/utils/styles';
import { SOURCE_ID } from '../sources/CoverageData';

export const REGION_ID = 'hm-regions';
const SOURCE_LAYER_ID = 'regions';
export const REGION_BORDERS_ID = 'hm-region-borders';

export function addLayer({
  map,
  selectedRegionId,
  shouldHighlightOnHover = true,
  onRegionClick,
  onRegionHovered,
}: {
  map: Map;
  selectedRegionId: string;
  shouldHighlightOnHover?: boolean;
  onRegionClick?: (e: MapLayerMouseEvent) => void;
  onRegionHovered?: (e: MapLayerMouseEvent | null) => void;
}) {
  if (!map.getLayer(REGION_ID)) {
    map.addLayer(
      {
        id: REGION_ID,
        type: 'fill',
        source: SOURCE_ID,
        'source-layer': SOURCE_LAYER_ID,
        paint: {
          'fill-color': hslStringToHex(colors.azure[600]),
          'fill-opacity': [
            'case',
            ['==', ['get', 'id'], selectedRegionId],
            0.2,
            ['boolean', ['feature-state', 'hover'], false],
            0.05,
            0,
          ],
        },
      },
      getFirstLabelId(map),
    );
  }

  if (!map.getLayer(REGION_BORDERS_ID)) {
    map.addLayer(
      {
        id: REGION_BORDERS_ID,
        type: 'line',
        source: SOURCE_ID,
        'source-layer': SOURCE_LAYER_ID,
        paint: {
          'line-color': hslStringToHex(colors.azure[500]),
          'line-width': 1,
        },
      },
      getFirstLabelId(map),
    );
  }

  map.on('click', REGION_ID, e => {
    onRegionClick?.(e);
  });

  let hoveredRegionId: string | null = null;
  map.on('mousemove', REGION_ID, e => {
    if (e.features && e.features?.length > 0) {
      if (hoveredRegionId !== null) {
        map.setFeatureState(
          {
            source: SOURCE_ID,
            sourceLayer: SOURCE_LAYER_ID,
            id: hoveredRegionId,
          },
          { hover: false },
        );
      }

      hoveredRegionId = e.features?.[0]?.id as string;
      if (hoveredRegionId) {
        if (shouldHighlightOnHover) {
          map.setFeatureState(
            {
              source: SOURCE_ID,
              sourceLayer: SOURCE_LAYER_ID,
              id: hoveredRegionId,
            },
            { hover: true },
          );
        }
        onRegionHovered?.(e);
      }
    }

    map.on('mouseleave', REGION_ID, () => {
      if (hoveredRegionId !== null) {
        map.setFeatureState(
          {
            source: SOURCE_ID,
            sourceLayer: SOURCE_LAYER_ID,
            id: hoveredRegionId,
          },
          { hover: false },
        );
      }
      hoveredRegionId = null;
      onRegionHovered?.(null);
    });
  });
}
